/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

export const handleSessionExpiredClose = () => {
    sessionStorage.clear();
    alert("Session expired, redirecting to Xero...")
    window.location.href = `${process.env.REACT_APP_SIGN_IN_URL}`;
};